/*eslint-disable */
import { useEffect, useRef } from 'react'
import { webSocketWorkerEvent } from '../../../services'
import { changeUtcTimeToLocal, paginationHandler } from '../../../helper'
import { DATE_FORMAT } from '../../../utils/constants'
import MTMCalculator from '../MTMCalculator'

const useTradeBlotterRequestHandler = ({
  gridScrollHight,
  tradeBlotterResponse,
  selected,
  disabled,
  page,
  tradesGroup,
  dealsGroup,
  unAllocatedDeals,
  pendingData,
  review,
  tradesGiveUp,
  setTradesGiveUp,
  tradesConversion,
  setTradesConversion,
  setReview,
  setTradeBlotterResponse,
  setPendingData,
  setLoading,
  setDisabled,
  expandsRow,
  gridRef,
  dealTradesGroup,
  getWidgets,
  pagination,
  setPagination,
  setDealsGroup,
  setTradesGroup,
  setDealsGiveUpGroup,
  setDealTradesGroup,
  setDealsNotSentToPb,
  selectedAllDeal,
  setSelectedAllDeal,
  setSelected,
  setUnAllocatedDeals,
  dispatchNotification,
  tradeBlotterDataAgGrid,
  priceRatesNormalize,
  totalPage,
  setTotalPage
}) => {
  const dealsIdRefresh = useRef([])
  const mtmCalculator = useRef(MTMCalculator)
  useEffect(() => {
    getWidgets()
  }, [])

  const handelTradeBlotterRefreshing = () => {
    setTimeout(() => {
      if (gridRef.current && gridRef.current.api && 'refreshServerSide' in gridRef.current.api) {
        let calculationsPerformed = 0
        let successfulCalculations = 0
        tradeBlotterDataAgGrid.current.forEach(node => {
          if (
            node.children?.length > 0 &&
            node.staging_status === 'Live' &&
            (node.status === null || node.status === 'NEW')
          ) {
            if (['Spot', 'NDF', 'Forward', 'Swap'].includes(node.type)) {
              let dealTotalMTM = 0
              let validTradeCount = 0
              let tradeResult
              node.children.forEach(trade => {
                calculationsPerformed++
                if (node.type !== 'Swap') {
                  tradeResult = mtmCalculator.current.calculateSpotNdfForwardTradeMTM(
                    trade,
                    priceRatesNormalize
                  )
                } else {
                  tradeResult = mtmCalculator.current.calculateSwapTradeMTM(
                    trade,
                    priceRatesNormalize
                  )
                }
                // Use the new method that calculates both client and market maker MTM

                if (tradeResult) {
                  trade.pnl_usd_live = tradeResult.total_mtm
                  trade.client_mtm = tradeResult.client_mtm
                  trade.market_maker_mtm = tradeResult.market_maker_mtm
                  trade.last_mtm_update = Date.now()

                  dealTotalMTM += tradeResult.total_mtm
                  validTradeCount++
                  successfulCalculations++
                }
              })

              // Aggregate MTM at deal level
              if (validTradeCount > 0) {
                node.pnl_usd_live = dealTotalMTM
                node.last_mtm_update = Date.now()
              }
            } else if (!['Spot', 'NDF', 'Forward', 'Swap'].includes(node.type)) {
              node.pnl_usd_live = node.pnl
            }
          }
        })
        if (dealsIdRefresh.current.length) {
          for (const dealId of dealsIdRefresh.current) {
            if (tradeBlotterDataAgGrid.current.length) {
              const dealData = tradeBlotterDataAgGrid.current.find(
                deal => Array.isArray(deal.children) && +deal.id === +dealId
              )
              const rowNode = gridRef.current.api.getRowNode(`${dealId}D`)
              const wasExpanded = rowNode?.expanded

              if (rowNode && dealData) {
                rowNode.setData(dealData)
              }
              if (wasExpanded) {
                setTimeout(() => rowNode.setExpanded(true), 40)
              }
            }

            gridRef.current.api.refreshServerSide({
              purge: true,
              route: [String(dealId)]
            }) // Refresh the grid
          }
        }

        dealsIdRefresh.current = []
        const resized = localStorage.getItem('resized')
        if (resized !== 'true') {
          const calls = gridRef.current.columnApi.getAllGridColumns().map(col => col.getColId())
          gridRef.current.columnApi.autoSizeColumns(calls)
        }
        gridRef.current.api.refreshServerSide({ purge: false }) // Refresh the grid
      }
    }, 100)
  }

  useEffect(() => {
    handelTradeBlotterRefreshing()
  }, [
    priceRatesNormalize,
    tradeBlotterDataAgGrid.current,
    gridRef.current,
    tradeBlotterResponse.data
  ])

  useEffect(() => {
    const handelMessage = message => {
      if (message.data.status === 'error' && message.data.data === "user don't have permission") {
        return dispatchNotification("you don't have booking permission", 'error')
      }

      if (
        (message.data.type === 'get_trade_blotter' ||
          message.data.type === 'get_trade_blotter_lucera' ||
          message.data.type === 'get_trade_blotter_letool') &&
        message.data.status === 'ok' &&
        message.data.data &&
        Array.isArray(message.data.data.tradeBlotterData)
      ) {
        let { status, data } = message.data
        const { tradeBlotterData, filters, max_deals, review, total_page } = data
        if (tradeBlotterData.length === 0) {
          setTradeBlotterResponse({
            status,
            data: tradeBlotterData
          })
          setReview(0)
          setLoading(false)
          setTotalPage(1)
          tradeBlotterDataAgGrid.current = []
          handelTradeBlotterRefreshing()

          paginationHandler(tradeBlotterData, page, { setDisabled, disabled })
          return
        }
        setPagination(requests => {
          requests[page] = filters
          return requests
        })
        setReview(review)
        setTotalPage(total_page)
        setSelectedAllDeal({ ...selectedAllDeal, maxDeals: max_deals })
        for (const element of tradeBlotterData) {
          element.trade_date = changeUtcTimeToLocal(
            element.trade_date,
            DATE_FORMAT.BLOTTER_DATE_TIME
          )
          if (Array.isArray(element.children)) {
            for (const trade of element.children) {
              trade.trade_date = changeUtcTimeToLocal(
                trade.trade_date,
                DATE_FORMAT.BLOTTER_DATE_TIME
              )
            }
          }
        }
        paginationHandler(tradeBlotterData, page, { setDisabled, disabled })
        if (['get_trade_blotter_lucera', 'get_trade_blotter_letool'].includes(message.data.type)) {
          if (gridScrollHight.current.top > 200 || expandsRow > 0) {
            setPendingData({
              status,
              data: tradeBlotterData
            })
          } else {
            setTradeBlotterResponse({
              status,
              data: tradeBlotterData
            })
            tradeBlotterDataAgGrid.current = tradeBlotterData
            handelTradeBlotterRefreshing()
            if (pendingData.status !== null) {
              setPendingData({
                status: null,
                data: []
              })
            }
          }
        } else {
          if (pendingData.status !== null) {
            setPendingData({ data: [], status: null })
          }
          setTradeBlotterResponse({
            status,
            data: tradeBlotterData
          })
        }
        tradeBlotterDataAgGrid.current = tradeBlotterData
        handelTradeBlotterRefreshing()
        setLoading(false)
      }

      const SUCCESS = 'success'
      if (
        message.data.type === 'update_trade' &&
        message.data.status === 'ok' &&
        message.data.data.trade_id
      ) {
        const id = Number(message.data.data.trade_id)
        dispatchNotification(`trade: ${id} is being update`, SUCCESS)
        if (id in tradesGroup || id in dealTradesGroup) {
          setSelected(select => select - 1)
        }

        setTradesGroup(lastTradeGroups => {
          delete lastTradeGroups[id]
          return lastTradeGroups
        })
        setDealTradesGroup(lastTradeGroups => {
          delete lastTradeGroups[id]
          return lastTradeGroups
        })
        setTradesConversion(lastTradesConversion => {
          delete lastTradesConversion[id]
          return lastTradesConversion
        })
      }

      if (
        message.data.type === 'refresh_deal' &&
        message.data.status === 'ok' &&
        message.data.data.deal_id
      ) {
        dealsIdRefresh.current.push(String(message.data.data.deal_id))
      }
      if (
        message.data.type === 'allocate_deal' &&
        message.data.status === 'ok' &&
        message.data.data.deals_id
      ) {
        const dealsId = message.data.data.deals_id
        dispatchNotification(`deal: ${dealsId.join(',')} is being allocated`, SUCCESS)
        setUnAllocatedDeals(lastUnAllocateDeal => {
          for (const dealId of dealsId) {
            const id = Number(dealId)
            if (id in lastUnAllocateDeal) {
              delete lastUnAllocateDeal[id]
            }
          }
          return lastUnAllocateDeal
        })

        if (dealsId.length > 1) {
          setDealsGroup(lastDealGroup => {
            let counter = 0
            for (const dealId of dealsId) {
              const id = Number(dealId)
              if (id in lastDealGroup) {
                delete lastDealGroup[id]
                counter++
              }
            }
            setSelected(select => select - counter)
            return lastDealGroup
          })

          setDealsNotSentToPb(lastDealsNotSentToPb => {
            for (const dealId of dealsId) {
              const id = Number(dealId)
              if (id in lastDealsNotSentToPb) {
                delete lastDealsNotSentToPb[id]
              }
            }
            return lastDealsNotSentToPb
          })

          setDealsGiveUpGroup(lastDealGiveUp => {
            for (const dealId of dealsId) {
              const id = Number(dealId)
              if (id in lastDealGiveUp) {
                delete lastDealGiveUp[id]
              }
            }
            return lastDealGiveUp
          })
        }
      }
      if (message.data.type === 'delete_trades_or_deals' && message.data.status === 'ok') {
        if (Array.isArray(message.data.data.trades_id) && message.data.data.trades_id.length > 0) {
          const { trades_id } = message.data.data
          dispatchNotification(`trades: ${trades_id.join(',')} is being delete`, SUCCESS)
          setDealTradesGroup(lastTradeGroups => {
            let counter = 0
            for (const tradeId of trades_id) {
              const id = Number(tradeId)
              if (id in lastTradeGroups) {
                counter++
                delete lastTradeGroups[id]
              }
            }
            setSelected(select => select - counter)
            return lastTradeGroups
          })

          setTradesGroup(lastTradesGroup => {
            let counter = 0
            for (const tradeId of trades_id) {
              const id = Number(tradeId)
              if (id in lastTradesGroup) {
                counter++
                delete lastTradesGroup[id]
              }
            }
            setSelected(select => select - counter)
            return lastTradesGroup
          })

          setTradesConversion(lastTradesConversion => {
            let counter = 0
            for (const tradeId of trades_id) {
              const id = Number(tradeId)
              if (id in lastTradesConversion) {
                counter++
                delete lastTradesConversion[id]
              }
            }
            setSelected(select => select - counter)
            return lastTradesConversion
          })

          setTradesGiveUp(lastTradesGiveUp => {
            let counter = 0
            for (const tradeId of trades_id) {
              const id = Number(tradeId)
              if (id in lastTradesGiveUp) {
                counter++
                delete lastTradesGiveUp[id]
              }
            }
            setSelected(select => select - counter)
            return lastTradesGiveUp
          })
        }

        if (Array.isArray(message.data.data.deals_id) && message.data.data.deals_id.length > 0) {
          const { deals_id } = message.data.data
          dispatchNotification(`deals: ${deals_id.join(',')} is being delete`, SUCCESS)

          setDealsGroup(lastDealGroup => {
            let counter = 0
            for (const dealId of deals_id) {
              const id = Number(dealId)
              if (id in lastDealGroup) {
                delete lastDealGroup[id]
                counter++
              }
            }
            setSelected(select => select - counter)
            return lastDealGroup
          })

          setUnAllocatedDeals(lastUnAllocateDeal => {
            for (const deal_id of deals_id) {
              if (deal_id in lastUnAllocateDeal) {
                delete lastUnAllocateDeal[deal_id]
              }
            }
            return lastUnAllocateDeal
          })

          setDealsNotSentToPb(lastDealsNotSentToPb => {
            for (const deal_id of deals_id) {
              const id = Number(deal_id)
              if (id in lastDealsNotSentToPb) {
                delete lastDealsNotSentToPb[id]
              }
            }
            return lastDealsNotSentToPb
          })

          setDealsGiveUpGroup(lastDealGiveUp => {
            for (const dealId of deals_id) {
              const id = Number(dealId)
              if (id in lastDealGiveUp) {
                delete lastDealGiveUp[id]
              }
            }
            return lastDealGiveUp
          })
        }
      }
      if (
        message.data.type === 'group_trades' &&
        message.data.status === 'ok' &&
        Array.isArray(message.data?.data?.trades_id)
      ) {
        const { trades_id } = message.data.data
        const tradesId = trades_id.map(tradeId => Number(tradeId))
        dispatchNotification(`trades: ${tradesId.join(',')} are being group to a deal`, SUCCESS)
        setTradesGroup(lastTradeGroups => {
          let counter = 0
          for (const tradeId of trades_id) {
            const id = Number(tradeId)
            if (id in lastTradeGroups) {
              counter++
              delete lastTradeGroups[id]
            }
          }
          setSelected(select => select - counter)
          return lastTradeGroups
        })
      }
      if (
        message.data.type === 'un_group_deals' &&
        message.data.status === 'ok' &&
        Array.isArray(message.data?.data?.deals_id)
      ) {
        const { deals_id } = message.data.data
        const dealsId = deals_id.map(dealId => Number(dealId))
        dispatchNotification(`deals: ${dealsId.join(',')} is/are being ungrouped`, SUCCESS)

        setDealsGroup(lastDealGroups => {
          let counter = 0
          for (const id of dealsId) {
            if (id in lastDealGroups) {
              counter++
              delete lastDealGroups[id]
            }
          }
          setSelected(select => select - counter)
          return lastDealGroups
        })
        setDealsNotSentToPb(lastDealsNotSentToPb => {
          for (const id of dealsId) {
            if (id in lastDealsNotSentToPb) {
              delete lastDealsNotSentToPb[id]
            }
          }
          return lastDealsNotSentToPb
        })

        setUnAllocatedDeals(lastUnAllocateDeal => {
          for (const deal_id of deals_id) {
            if (deal_id in lastUnAllocateDeal) {
              delete lastUnAllocateDeal[deal_id]
            }
          }
          return lastUnAllocateDeal
        })

        setDealsGiveUpGroup(lastDealGiveUpGroup => {
          for (const id of dealsId) {
            delete lastDealGiveUpGroup[id]
          }
          return lastDealGiveUpGroup
        })
      }
      if (
        message.data.type === 'give_up_deals' &&
        message.data.status === 'ok' &&
        (Array.isArray(message.data?.data?.deals_id) ||
          Array.isArray(message.data?.data?.trades_id))
      ) {
        const { deals_id, trades_id } = message.data.data
        const dealsId = deals_id.map(dealId => Number(dealId))
        const tradesId = trades_id.map(tradeId => Number(tradeId))
        if (dealsId.length) {
          dispatchNotification(`deals: ${dealsId.join(',')} is/are being Live`, SUCCESS)
        }
        if (tradesId.length) {
          dispatchNotification(`trades:${tradesId.join(',')} is/are being conversion/s`)
        }
        if (dealsId.length) {
          setDealsGroup(lastDealGroups => {
            for (const id of dealsId) {
              if (id in lastDealGroups) {
                delete lastDealGroups[id]
              }
            }
            return lastDealGroups
          })

          setDealsGiveUpGroup(lastDealGiveUpGroup => {
            let counter = 0
            for (const id of dealsId) {
              counter++
              delete lastDealGiveUpGroup[id]
            }
            setSelected(select => select - counter)
            return lastDealGiveUpGroup
          })
          setDealsNotSentToPb(lastDealNotSentToPb => {
            for (const id of dealsId) {
              delete lastDealNotSentToPb[id]
            }
            return lastDealNotSentToPb
          })
        }
        if (tradesId.length) {
          setTradesGiveUp(lastTradesGiveUp => {
            for (const id of tradesId) {
              if (id in lastTradesGiveUp) {
                delete lastTradesGiveUp[id]
              }
            }
            return lastTradesGiveUp
          })
        }
      }
    }

    webSocketWorkerEvent.addEventListener('message', handelMessage)
    return () => webSocketWorkerEvent.removeEventListener('message', handelMessage)
  }, [
    webSocketWorkerEvent,
    gridScrollHight,
    pagination,
    gridRef,
    dealsIdRefresh,
    tradesGiveUp,
    unAllocatedDeals,
    tradesConversion,
    tradeBlotterResponse,
    selected,
    disabled,
    page,
    expandsRow,
    selectedAllDeal,
    tradesGroup,
    dealsGroup,
    review,
    priceRatesNormalize
  ])
}

export default useTradeBlotterRequestHandler
